// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content-teasers.text-icon-teaser .footer[data-v-a24e06a2],.content-teasers.text-icon-teaser .header[data-v-a24e06a2],.content-teasers.text-icon-teaser .main[data-v-a24e06a2]{height:100%;width:100%;flex-basis:33%}.content-teasers.text-icon-teaser .footer[data-v-a24e06a2]{font-size:2.5em}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
